import React from 'react';
import { Clock } from 'lucide-react';

interface QueuedCaseBannerProps {
  pageLimit?: number | null;
}

export const QueuedCaseBanner: React.FC<QueuedCaseBannerProps> = ({ pageLimit }) => {
  return (
    <div className="border rounded-lg px-4 py-3 flex items-start gap-3 bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-700 text-orange-800 dark:text-orange-200">
      <Clock className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <div className="text-sm">
        <p className="font-medium">Case queued for review</p>
        <p className="mt-1">
          This case exceeds the auto-processing limit
          {pageLimit ? ` of ${pageLimit.toLocaleString()} pages` : ''} and
          has been queued for manual review. Processing will be complete
          within 24–48 hours.{' '}
          <a
            href="mailto:support@clinlexis.co.uk?subject=Queued%20case%20enquiry"
            className="underline font-medium hover:text-orange-900 dark:hover:text-orange-100"
          >
            Contact support
          </a>{' '}
          for more information.
        </p>
      </div>
    </div>
  );
};
